import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onCancel?: () => void;
}

export default function AppUnsavedChangesDialog({
  open,
  onClose,
  onConfirm,
  title = "Niezapisane zmiany",
  message = "Wprowadziłeś zmiany, które nie zostały zapisane. Czy na pewno chcesz opuścić formularz? Niezapisane zmiany zostaną utracone.",
  confirmText = "Opuść bez zapisywania",
  cancelText = "Pozostań",
  onCancel
}: Props) {
  // Use onCancel if provided, otherwise use onClose
  const handleCancel = onCancel || onClose;
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="unsaved-changes-dialog-title"
      aria-describedby="unsaved-changes-dialog-description"
    >
      <DialogTitle id="unsaved-changes-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="unsaved-changes-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', px: 2, pb: 2 }}>
        <Button onClick={handleCancel} color="primary" variant="outlined">
          {cancelText}
        </Button>
        <Button onClick={onConfirm} color="error" variant="outlined">
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}